// extracted by mini-css-extract-plugin
export default {"stack-thumb":"_9L3kV","stackThumb":"_9L3kV"};